var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-toolbar',{attrs:{"app":""}},[_c('v-avatar',[_c('v-img',{attrs:{"src":"/img/logo_simple.png"}})],1),_c('v-toolbar-title',[_vm._v("Acocasa")])],1),_c('v-content',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }